import '../grand_league_leaderboard_list/index.css';
import {
  View,
  Text,
  PlaceHolder,
  ErrorMessage,
  EmptyData,
  FlatListAutoHeight
} from '../../../component';
import FlatList from 'flatlist-react';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  getWeekendContestLeaderBoard,
  getMyWeekendContestLeaderBoard
} from '../../../actions/fantasy-cricket-action-types';
import useTheme from '../../../utilities/hooks/theme';
import { maskUserName } from '../../../utilities/helper';

const WeekendLeaderboardList = () => {
  const { FantasyTheme: theme } = useTheme();
  const dispatch = useDispatch();
  const [leaderboardList, setLeaderBoardList] = useState([]);
  const [megaUserScore, setMegaUserScore] = useState(0);
  const [resultArrived, setResultArrived] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    onPressRetry();
  }, []);

  const getWeekendLeaderBoard = () => {
    dispatch(
      getWeekendContestLeaderBoard({
        callback: ({ result, error }: { result: any; error: any }) => {
          if (!error) {
            if (result) {
              setLeaderBoardList(result);
            }
            setResultArrived(true);
            setError(false);
          } else {
            setError(true);
          }
        }
      })
    );
  };

  const getUserWeekendLeaderBoard = () => {
    dispatch(
      getMyWeekendContestLeaderBoard({
        callback: ({ result = [], error }: { result: any; error: any }) => {
          if (!error && result && result[0]?.megaLeagueScore) {
            setMegaUserScore(result[0].megaLeagueScore);
          }
        }
      })
    );
  };

  const renderItem = (item: any) => {
    const { megaLeagueScore = 0, rank = 0, username = '', _id = '' } = item;
    const itemTitleStyle = {
      color: theme.GLLeaderBoardWinningItemTitle,
      backgroundColor: theme.GLLeaderBoardWinningItemBoxBG
    };
    const maskUserName_ = maskUserName('', '', username);
    return (
      <View key={_id} className="grand-league-leaderboard-list-container">
        <Text
          style={itemTitleStyle}
          className="grand-league-leaderboard-list-item-title">{`${maskUserName_}`}</Text>
        <Text
          style={{
            ...itemTitleStyle,
            width: '80px'
          }}
          className="grand-league-leaderboard-list-item-title">{`${rank}`}</Text>
        <Text
          style={{
            ...itemTitleStyle,
            width: '80px'
          }}
          className="grand-league-leaderboard-list-item-title">{`${megaLeagueScore}`}</Text>
      </View>
    );
  };

  const onPressRetry = () => {
    getWeekendLeaderBoard();
    getUserWeekendLeaderBoard();
  };

  const renderWhenEmpty = () => {
    if (!resultArrived) return <PlaceHolder.Loader />;
    if (error) return <ErrorMessage onPressRetry={onPressRetry} />;
    return <EmptyData message={'To be updated...'} />;
  };

  const headerTitle = {
    backgroundColor: theme.GLLeaderBoardWinningHeaderBoxBG,
    color: theme.GLLeaderBoardWinningHeaderTitle
  };

  return (
    <View className="grand-league-leaderboard-list-wrapper">
      {resultArrived && (
        <View className="grand-league-leaderboard-list-my-score-wrapper">
          <Text style={headerTitle} className="grand-league-leaderboard-list-my-score">
            {`Your Score : ${megaUserScore}`}
          </Text>
        </View>
      )}
      <View className="grand-league-leaderboard-list-container">
        <Text
          style={headerTitle}
          className="grand-league-leaderboard-list-header-title">{`User Name`}</Text>
        <Text
          style={{
            ...headerTitle,
            width: '80px'
          }}
          className="grand-league-leaderboard-list-header-title">{`Rank`}</Text>
        <Text
          style={{
            ...headerTitle,
            width: '80px'
          }}
          className="grand-league-leaderboard-list-header-title">{`Score`}</Text>{' '}
      </View>
      <FlatListAutoHeight>
        <FlatList
          list={leaderboardList}
          renderItem={renderItem}
          renderWhenEmpty={renderWhenEmpty}
          renderOnScroll
        />
      </FlatListAutoHeight>
    </View>
  );
};
export default WeekendLeaderboardList;
